import PhotoSwipeGallery from "../PhotoSwipeGallery";
import { useInView } from "react-intersection-observer";

export const ImageGallery = ({ heading, copy, gridImages, className }) => {
  const [slideUpRef, isInView] = useInView({ triggerOnce: true });
  return (
    <div
      className={`tw-flex tw-flex-col tw-gap-8 tw-items-center tw-text-center ${
        isInView ? "slide-up" : ""
      } ${className}`}
      ref={slideUpRef}
    >
      <div className="tw-flex tw-flex-col tw-gap-2">
        {heading && <h2 className="heading2">{heading}</h2>}
        {copy && <div dangerouslySetInnerHTML={{ __html: copy }} />}
      </div>
      {gridImages && (
        <div className="tw-w-full">
          <PhotoSwipeGallery
            galleryHtml={gridImages}
            galleryId="events-alt-gallery"
          />
        </div>
      )}
    </div>
  );
};
